'use client';
import * as React from 'react';
import ErrorPage from '@/components/ui/ErrorPage';

const GlobalError: React.FunctionComponent = () => {
  return (
    <div id="__next">
      <ErrorPage
        subTitle="Internal server error"
        description="Our rocket scientists are working as quickly as possible to bring you to the moon."
        imageMobile="/images/jackpot/error-500-mobile.jpg"
        imageTablet="/images/jackpot/error-500-tablet.jpg"
        imageDesktop="/images/jackpot/error-500-desktop.jpg"
      />
    </div>
  );
};
GlobalError.displayName = 'GlobalError';
export default GlobalError;
